// components/header/PrescriptionHeader.tsx
import React from 'react';
import { X, FileText, Calendar, Clock, Eye, Edit3 } from 'lucide-react';

interface PrescriptionHeaderProps {
  medicationCount: number;
  isPreviewMode: boolean;
  onTogglePreview: () => void;
  onPrint: () => void;
  onClose: () => void;
}

const PrescriptionHeader: React.FC<PrescriptionHeaderProps> = ({
  medicationCount,
  isPreviewMode,
  onTogglePreview,
  // onPrint,
  onClose
}) => {
  return (
    <div className="bg-gradient-to-r from-blue-600 via-blue-700 to-indigo-700 text-white p-4 sm:p-6">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div>
          <h2 className="text-2xl sm:text-3xl font-bold flex items-center mb-2">
            <FileText className="mr-3" size={28} />
            Interface d'Ordonnance Médicale
          </h2>
          <div className="flex flex-wrap items-center gap-4 text-blue-100 text-sm">
            <span className="flex items-center">
              <Calendar className="mr-1" size={14} />
              {new Date().toLocaleDateString("fr-FR")}
            </span>
            <span className="flex items-center">
              <Clock className="mr-1" size={14} />
              {new Date().toLocaleTimeString("fr-FR", {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </span>
            <span className="flex items-center">
              <FileText className="mr-1" size={14} />
              {medicationCount} médicament{medicationCount !== 1 ? "s" : ""}
            </span>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={onTogglePreview}
            className="p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors flex items-center text-sm"
            title={isPreviewMode ? "Mode édition" : "Mode aperçu"}
          >
            {isPreviewMode ? <Edit3 size={18} /> : <Eye size={18} />}
            <span className="ml-1 hidden sm:inline">
              {isPreviewMode ? "Éditer" : "Aperçu"}
            </span>
          </button>
          {/* <button
            onClick={onPrint}
            className="p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors flex items-center text-sm"
            title="Imprimer"
          >
            <Printer size={18} />
            <span className="ml-1 hidden sm:inline">Imprimer</span>
          </button> */}
          <button
            onClick={onClose}
            className="p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors"
            title="Fermer"
          >
            <X size={24} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrescriptionHeader;